export default __webpack_public_path__ + "static/media/signal-medium.1a8d896f.svg";